import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { FinancialEntityBranch } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface FinancialEntityBranchesParams extends DefaultHttpHeaders {
  /** Between 4 or 5 numeric characters which identifies the main bank (ABI) */
  financialEntityCode: string;
  /** Between 4 or 5 numeric characters which identifies the local bank. (CAB) */
  financialEntityBranchCode?: string;
  /** Town zipCode of the location of the branch. */
  zipCode?: string;
  /** Town code of the branch. */
  townCode?: string;
}

@Injectable()
export class FinancialEntityBranchesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }
  // tslint:disable max-line-length
  /**
   * Service for obtaining financial branches
   * Service for obtaining financial branches
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/getFinancialEntityBranches
   */
  financialEntityBranches(params: FinancialEntityBranchesParams): Observable<FinancialEntityBranch[]> {
    const queryParams = {
      financialEntityCode: params.financialEntityCode,
      financialEntityBranchCode: params.financialEntityBranchCode,
      zipCode: params.zipCode,
      townCode: params.townCode,
    };

    return this.get<FinancialEntityBranch[]>({
      suffix: '/comeround/applicationUtilities/financialEntityBranches',
      queryParams,
    });
  }
}
